<script setup lang="ts">
    import { ref, computed, onMounted } from 'vue'
    import { useModulHandbuchStore } from '@/js/stores/modulHandbuch'
    import {
        FileInputField,
        GlobalFormError,
        InfoAlert,
        SuccessAlert
    } from '@/js/components/Common'
    import { getViolationsFeedback, useUploadFile } from '@/js/utils'

    const { file, readFileAsUrl } = useUploadFile()
    const store = useModulHandbuchStore()

    const isFinished = ref<boolean>(false)

    const modulUploadState = computed<boolean | undefined>(() => {
        if (file.value === null) {
            return
        }

        return Boolean(file.value)
    })

    const isLoading = computed<boolean>(() => {
        return store.isLoading
    })

    const error = computed(() => {
        return store.hasErrors
    })

    const globalErrors = computed(() => {
        return getViolationsFeedback(['fileData'], error.value, true)
    })

    onMounted(() => {
        isFinished.value = false
    })

    const handleModulHandBuchUpload = async (): Promise<void> => {
        isFinished.value = await store.uploadModulHandBuecherFile(
            await readFileAsUrl()
        )
    }
</script>

<template>
    <div>
        <v-form class="pa-2" @submit.prevent="handleModulHandBuchUpload">
            <file-input-field
                v-model="file"
                accept=".csv"
                placeholder="Ziehen Sie die CSV-Datei mit weiteren anzulegenden Modulhandbüchern hier rein..."
                label="Ziehen Sie die CSV-Datei mit weiteren anzulegenden Modulhandbüchern hier rein..."
                data-test="input-upload-modulhandbuch"
                :violation-fields="['fileData']"
                :error="error"
                :is-loading="isLoading"
                :disabled="modulUploadState === null"
            />
            <v-btn
                type="submit"
                block
                color="primary"
                variant="tonal"
                data-test="button-upload-modul"
                :disabled="!modulUploadState || isLoading"
                class="mt-2"
            >
                Modulimport starten
            </v-btn>
            <global-form-error :error="globalErrors" is-html />
            <success-alert :show="isFinished" message="Modul erfolgreich importiert." />
            <info-alert :show="true">
                <b>Hinweis:</b>
                <ul class="mb-0">
                    <li>
                        Die Nutzerliste muss bereits importiert sein, damit die Rollen der Lehrenden
                        aus dem Modulhandbuch den richtigen Nutzern zugewiesen werden können.
                    </li>
                </ul>
            </info-alert>
        </v-form>
    </div>
</template>

<style scoped></style>
